import React from 'react';
import { View } from 'react-native';
import { useRouter } from 'expo-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Query } from '@/utils/react-query/Queries';
import { QueryKeys } from '@/utils/react-query/QueryKeys';
import { createAutomation } from '@/data/automations';
import TriggerConfigSheet from '@/components/Paths/v2/TriggerConfigSheet';
import { StyleSheet } from 'react-native-unistyles';

/**
 * New v2 Automation — trigger-first create flow (spec §14.4).
 * Pick the ONE trigger (family → event → configured source) up front; the
 * definition is created as schemaVersion 2 / GENERIC / inactive, then the
 * builder takes over. This is the only creation surface — legacy creation is
 * retired; /automations/create redirects here unless editing (?id=).
 */
export default function NewAutomationScreen() {
    const router = useRouter();
    const queryClient = useQueryClient();
    const { data: catalog } = Query.automations.triggerCatalog();
    const { data: loggedInUser } = Query.people.loggedInUser();

    const createMutation = useMutation({
        mutationFn: createAutomation,
        onSuccess: (path) => {
            queryClient.invalidateQueries({ queryKey: QueryKeys.paths.all() });
            if (path?.id) {
                router.back();
                setTimeout(() => router.push('/automations/' + path.id), 100);
            }
        },
    });

    const handleSave = (triggerType, triggerConfig, inputSchema, definition) => {
        createMutation.mutate({
            name: definition.name.trim(),
            description: definition.description?.trim() || null,
            createdBy: loggedInUser?.id,
            triggerType,
            triggerConfig,
            inputSchema: inputSchema?.fields?.length ? inputSchema : null,
        });
    };

    return (
        <View style={styles.container}>
            <TriggerConfigSheet
                isOpen
                onClose={() => router.back()}
                catalog={catalog || []}
                showDefinitionFields
                onSave={handleSave}
                saving={createMutation.isPending}
                organizationID={loggedInUser?.organizationID}
            />
        </View>
    );
}

const styles = StyleSheet.create(() => ({
    container: { flex: 1 },
}));
